import { Component, Input, OnInit } from '@angular/core';
import { Annotation } from '../../models/Annotation';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';
import { SessionService } from '../../services/Session.service';

@Component({
  selector: 'app-annotation-records',
  templateUrl: './annotation-records.component.html'
})
export class AnnotationRecordsComponent implements OnInit {

  constructor(private loginService: LoginService, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private graphQlService: GraphqlService, private clipboard: Clipboard,
    public dialog: MatDialog, private session: SessionService) {
  }

  @Input() paragraphId: string = "";
  @Input() lineBool: string = "";
  @Input() annotations: any[] = [];
  @Input() annotationWithInContent: boolean = false;
  @Input() labels: any;
  @Input() isParaNum: boolean = true;
  shareLinkLabel: string;
  editLinkLabel: string;
  deleteLinkLabel: string;
  versionTextLabel: string;
  addedTextLabel: string;
  userId: string = "";
  mailId: string = "";
  annotationContent: Annotation[] = [];

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getUserId();
    this.getYourAnnotationLabel();
    this.commonDataService.removeAnnotationFromArray.subscribe(id => {
      if (id != "") {
        this.annotationContent = this.annotationContent.filter(x => x.id != id);
        this.commonDataService.showLoader.next(false);
      }
    });
  }

  getYourAnnotationLabel() {
    this.labels = this.labels?.filter(x => x.key.trim());
    this.shareLinkLabel = this.labels?.filter(x => x.key == "global_share").map(y => y.value);
    this.editLinkLabel = this.labels?.filter(x => x.key == "global_edit").map(y => y.value);
    this.deleteLinkLabel = this.labels?.filter(x => x.key == "global_delete").map(y => y.value);
    this.versionTextLabel = this.labels?.filter(x => x.key == "global_version").map(y => y.value);
    this.addedTextLabel = this.labels?.filter(x => x.key == "global_added").map(y => y.value);
  }

  getAnnotation() {
    this.httpCallService.getAnnotation(this.paragraphId, "false").subscribe((resp: any) => {
      this.annotationContent = resp;
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.commonDataService.userId.next(data.user.userName);
        this.commonDataService.mailId.next(data.user.email);
        this.userId = data.user.userName;
        this.mailId = data.user.email;
        if (!this.annotationWithInContent) {
          this.getAnnotation();
        } else {
          this.annotationContent = this.annotations;
          this.commonDataService.showLoader.next(false);
        }
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userId = this.session.userInfo.user.userName;
      this.mailId = this.session.userInfo.user.email;
      if (!this.annotationWithInContent) {
        this.getAnnotation();
      } else {
        this.annotationContent = this.annotations;
        this.commonDataService.showLoader.next(false);
      }
    }
  }

  editAnnotation(annotation: Annotation) {
    if (this.lineBool) {
      this.commonDataService.annotationUpdateSource.next("AnnotationWithinContent");
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.annotationContent.next(annotation);
      this.commonDataService.rightOverlayOption.next("Add Annotation");
    }
    else {
      this.commonDataService.annotationUpdateSource.next("Your Annotation");
      this.commonDataService.annotationContent.next(annotation);
      this.commonDataService.rightOverlayOption.next("Add Annotation");
    }
  }

  deleteAnnotation(annotation: Annotation) {
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.annotationDeletionConfirmationPromptMessage
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonDataService.isConfirmationPopUpOpen.next(false);
        this.commonDataService.showLoader.next(true);
        var deleteAnnotation: Annotation = {
          id: annotation.id, topicId: annotation.topicId, paragraphId: annotation.paragraphId, annotationTitle: annotation.annotationTitle,
          annotationDescription: annotation.annotationDescription, 
          application: "", createdOn: annotation.createdOn, modifiedOn: "", breadCrumb: annotation.breadCrumb, isDeleted: true, annotationsURL: annotation.annotationsURL,
          area: annotation.area, navigationPath: annotation.navigationPath
        }
        this.httpCall(deleteAnnotation);
      }
    });
  }

  httpCall(annotation: Annotation) {
    this.httpCallService.addUpdateAnnotation(annotation).toPromise()
      .then(response => {
        if (response == "Annotation added successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.commonDataService.deleteAnnotationParagraphId.next(annotation.paragraphId);
          //  this.removeAnnotationFromArray(annotation);
          this.commonDataService.removeAnnotationFromArray.next(annotation.id);

        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }

  removeAnnotationFromArray(annotation: Annotation) {
    this.annotationContent = this.annotationContent.filter(x => x.id != annotation.id);
  }

  copyToClipboard(annotation: Annotation) {
    const Regex = /(\~)/g;
    let span = document.createElement('span');
    span.innerHTML = annotation.breadCrumb.split("____")[0];
    let breadCrumb = span.innerText.trim().replace(/\s+/g, " ").replace(Regex, ' -> ');
    this.clipboard.copy("Annotation: " + annotation.annotationDescription + "\nLink: " + location.origin + annotation.annotationsURL + "\nLocation: " + breadCrumb);
    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }
}
